// extracted by mini-css-extract-plugin
module.exports = {"press":"f47fbe","pressInner":"d54578"};